import api from './apiLives';

import { global } from './global'

import { apicode } from './apicode'

export const data_live = {

    async tela(id) {

        const response = await api.get(`users/${id}`)
        if (response.data) { return response.data } else { return null }

    },

    async mostrarcanais(lista) {

        const response = await api.get(`mostrarcanais/${lista}`)
        if (response.data) {

            const { retorno } = response.data

        //  console.log(retorno, 'retorno')

            const retorno2 = apicode._decode(retorno);

      //   console.log(retorno2, 'retorno2')

            return retorno2
        }
        else { return null }
    },

    async Listar(oid, page, filter) {
        try {
            if (filter != null) {
                const response = await api.get(`livesmostrarax/${oid}/${page}/${filter}`);
                if (response.data) {

                    const { retorno } = response.data
        
               //   console.log(retorno, 'retorno')
        
                    const retorno2 = apicode._decode(retorno);
        
              //   console.log(retorno2, 'retorno2')
        
                    return retorno2
                }
                else { return null }
            } else {
                const response = await api.get(`livesmostrarax/${oid}/${page}`);
                if (response.data) {

                    const { retorno } = response.data
        
             //     console.log(retorno, 'retorno')
        
                    const retorno2 = apicode._decode(retorno);
        
              //   console.log(retorno2, 'retorno2')
        
                    return retorno2
                }
                else { return null }
            }
        } catch (error) {
            return null
        }
    },

    async Listar1(oid, page, filter) {
        try {
            if (filter != null) {
                const response = await api.get(`livesmostrarbx/${oid}/${page}/${filter}`);
                if (response.data) {

                    const { retorno } = response.data
        
              //    console.log(retorno, 'retorno')
        
                    const retorno2 = apicode._decode(retorno);
        
              //   console.log(retorno2, 'retorno2')
        
                    return retorno2
                }
                else { return null }
            } else {
                const response = await api.get(`livesmostrarbx/${oid}/${page}`);
                if (response.data) {

                    const { retorno } = response.data
        
              //    console.log(retorno, 'retorno')
        
                    const retorno2 = apicode._decode(retorno);
        
             //    console.log(retorno2, 'retorno2')
        
                    return retorno2
                }
                else { return null }
            }
        } catch (error) {
            return null
        }
    },

    async Listar2(oid, page, filter) {
        try {
            if (filter != null) {
                const response = await api.get(`livesmostrarcx/${oid}/${page}/${filter}`);
                if (response.data) {

                    const { retorno } = response.data
        
               //   console.log(retorno, 'retorno')
        
                    const retorno2 = apicode._decode(retorno);
        
              //   console.log(retorno2, 'retorno2')
        
                    return retorno2
                }
                else { return null }
            } else {
                const response = await api.get(`livesmostrarcx/${oid}/${page}`);
                if (response.data) {

                    const { retorno } = response.data
        
              //    console.log(retorno, 'retorno')
        
                    const retorno2 = apicode._decode(retorno);
        
               //  console.log(retorno2, 'retorno2')
        
                    return retorno2
                }
                else { return null }
            }
        } catch (error) {
            return null
        }
    },




    async Trailer() {
        try {

            const response = await api.get(`mostrartrailerx`);
            if (response.data) {

                const { retorno } = response.data
    
            //  console.log(retorno, 'retorno')
    
                const retorno2 = apicode._decode(retorno);
    
          //   console.log(retorno2, 'retorno2')
    
                return retorno2
            }
            else { return null }

        } catch (error) {
            return null
        }
    },



    async liveentrar(id) {

        var data = { versao: global.brl.REACT_APP_VERSAO }

        const response = await api.put(`liveentrar/${id}`, data)
        if (response.data) { return response.data } else { return null }




    },

    async livesair(id) {

        var data = { versao: global.brl.REACT_APP_VERSAO }

        const response = await api.put(`livesair/${id}`, data)
        if (response.data) { return response.data } else { return null }

    },





};
